module.exports = __webpack_public_path__ + "static/media/back-button.6678f8d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/back-button.png
// module id = 103
// module chunks = 0